export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

/** ring ที่มองเห็นชัดบนพื้นสว่าง — ใช้ทุก component ที่โฟกัสได้ */
export const focusRing =
  'outline-none focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:ring-[var(--focus-ring-color)] focus-visible:ring-offset-[var(--surface-0)]';

/** ring บนพื้นน้ำเงินเข้ม */
export const focusRingOnBlue =
  'outline-none focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:ring-white focus-visible:ring-offset-[var(--blue-700)]';

/** พื้นที่กดสัมผัสขั้นต่ำตามข้อกำหนด (44x44px) */
export const touchTarget = 'min-h-[var(--touch-min)] min-w-[var(--touch-min)]';

export const thaiText = 'font-[family-name:var(--font-thai)] leading-[var(--leading-thai)]';
export const numText = 'font-[family-name:var(--font-num)] tabular-nums';
